export const GET_BOOSTER_PLAN_MIN_AMOUNT = "GET_BOOSTER_PLAN_MIN_AMOUNT";
export const GET_BOOSTER_PLAN_MIN_AMOUNT_SUCCESS =
  "GET_BOOSTER_PLAN_MIN_AMOUNT_SUCCESS";
export const GET_BOOSTER_PLAN_MIN_AMOUNT_FAILED =
  "GET_BOOSTER_PLAN_MIN_AMOUNT_FAILED";

export const GET_ADVANCE_PLAN_MIN_AMOUNT = "GET_ADVANCE_PLAN_MIN_AMOUNT";
export const GET_ADVANCE_PLAN_MIN_AMOUNT_SUCCESS =
  "GET_ADVANCE_PLAN_MIN_AMOUNT_SUCCESS";
export const GET_ADVANCE_PLAN_MIN_AMOUNT_FAILED =
  "GET_ADVANCE_PLAN_MIN_AMOUNT_FAILED";

export const GET_MIXED_FUNDS = "GET_MIXED_FUNDS";
export const GET_MIXED_FUNDS_SUCCESS = "GET_MIXED_FUNDS_SUCCESS";
export const GET_MIXED_FUNDS_FAILED = "GET_MIXED_FUNDS_FAILED";

export const GET_EQUITY_FUNDS = "GET_EQUITY_FUNDS";
export const GET_EQUITY_FUNDS_SUCCESS = "GET_EQUITY_FUNDS_SUCCESS";
export const GET_EQUITY_FUNDS_FAILED = "GET_EQUITY_FUNDS_FAILED";

export const GET_IMMF_FUND = "GET_IMMF_FUND";
export const GET_IMMF_FUND_SUCCESS = "GET_IMMF_FUND_SUCCESS";
export const GET_IMMF_FUND_FAILED = "GET_IMMF_FUND_FAILED";
